import { render, staticRenderFns } from "./FieldsetCustomerIdentification.vue?vue&type=template&id=1f464b17&scoped=true&"
import script from "./FieldsetCustomerIdentification.vue?vue&type=script&lang=js&"
export * from "./FieldsetCustomerIdentification.vue?vue&type=script&lang=js&"
import style0 from "./FieldsetCustomerIdentification.vue?vue&type=style&index=0&id=1f464b17&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f464b17",
  null
  
)

export default component.exports